import { render } from "./OrderStatusTracker.vue?vue&type=template&id=60d0742e&scoped=true"
import script from "./OrderStatusTracker.vue?vue&type=script&lang=js"
export * from "./OrderStatusTracker.vue?vue&type=script&lang=js"

import "./OrderStatusTracker.vue?vue&type=style&index=0&id=60d0742e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d0742e"]])

export default __exports__